// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import { Biography } from "./types/bioApiTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedBiosApi = createApi({
    reducerPath: "cclTokenedBiosApi",
    tagTypes: [],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllBios: builder.query<Biography[], any>({
            query: () => ({
                url: "enterprise-coaching/v1/Biography/biography/all",
                method: "GET",
            }),
        }),
        getBioByEmail: builder.query<Biography, string>({
            query: (email) => ({
                url: `enterprise-coaching/v1/Biography/biography/by-email/${encodeURIComponent(
                    email
                )}`,
                method: "GET",
            }),
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLazyGetBioByEmailQuery } = cclTokenedBiosApi;
